import React from 'react';
import { Modal } from '@/types/modal';
// ITEM
import Timeline from '@/components/modals/Timeline';
import UpdateItemAttribute from '@/components/modals/UpdateItemAttribute';
import UpdateItemDescription from '@/components/modals/UpdateItemDescription';
import UpdateItemComment from '@/components/modals/UpdateItemComment';
import CancelOrder from '@/components/modals/CancelOrder';
import ItemReturnFromWarehouse from '@/components/modals/ItemReturnFromWarehouse';
import ItemRelistSeller from '@/components/modals/ItemRelistSeller';
import ItemRelistWarehouse from '@/components/modals/ItemRelistWarehouse';
import ItemRelistBuyer from '@/components/modals/ItemRelistBuyer';
import ItemReleasePayment from '@/components/modals/ItemReleasePayment';
import ItemProofOfPayment from '@/components/modals/ItemProofOfPayment';
import ItemProofOfRefund from '@/components/modals/ItemProofOfRefund';
import ItemReturnToWarehouse from '@/components/modals/ItemReturnToWarehouse';
import ItemReturnToSeller from '@/components/modals/ItemReturnToSeller';
import ItemLostInTransit from '@/components/modals/ItemLostInTransit';
import ItemPLConfirmation from '@/components/modals/ItemPLConfirmation';
import ItemWithdrawFromSale from '@/components/modals/ItemWithdrawFromSale';
import ItemCurationPriority from '@/components/modals/ItemCurationPriority';
import ItemCurationStatus from '@/components/modals/ItemCurationStatus/ItemCurationStatus';
import ItemPhotos from '@/components/modals/ItemPhotos';
import ItemPhotoUpload from '@/components/modals/ItemPhotoUpload';
import ItemPhotoDelete from '@/components/modals/ItemPhotoDelete';
import ItemPhotoOrder from '@/components/modals/ItemPhotoOrder';
import ItemConfirmDelivered from '@/components/modals/ItemConfirmDelivered';
// ORDER
import UpdateOrderDeliveryHome from '@/components/modals/UpdateOrderDeliveryHome';
import RemovePickupDeliveryAddress from '@/components/modals/RemovePickupDeliveryAddress';
import OrderCreateRefund from '@/components/modals/OrderCreateRefund';
import OrderCreateExtraRefund from '@/components/modals/OrderCreateExtraRefund';
// Client
import UpdateEmail from '@/components/modals/UpdateEmail';
import UpdateClientShippingAddress from '@/components/modals/UpdateClientShippingAddress';
import TalononeNewPromoCode from '@/components/modals/TalononeNewPromoCode';
import TalononeExtendPromoCode from '@/components/modals/TalononeExtendPromoCode';
import TalononeDisablePromoCode from '@/components/modals/TalononeDisablePromoCode';
import ClientActionHisto from '@/components/modals/ClientActionHisto';
import ClientCanceledSales from '@/components/modals/ClientCanceledSales';
import Error from '@/components/modals/Error';
import Loading from '@/components/modals/Loading';
import Success from '@/components/modals/Success';
import OrderInvoice from '@/components/modals/OrderInvoice';
import ClientBadges from '@/components/modals/ClientBadges/ClientBadges';
import ClientCsScoreHistory from '@/components/modals/ClientCsScoreHistory';
import ClientSalesReports from '@/components/modals/ClientSalesReports';
import GetPaidManualVerification from './GetPaidManualVerification';
import ItemOrderAutoCancellation from '@/components/modals/ItemOrderAutoCancellation';
import ItemInterception from '@/components/modals/ItemInterception';
import ItemCreateReturnLitigation from '@/components/modals/PortalLitigation/ItemCreateReturnLitigation';
import ItemCreateSellerReturnLitigationModal from '@/components/modals/PortalLitigation/ItemCreateSellerReturnLitigationModal';
import ItemReplaceReturnLitigation from '@/components/modals/ItemReplaceReturnLitigation';
import ItemSubmitShippingLabel from '@/components/modals/ItemSubmitShippingLabel';
import ItemGetShippingLabel from '@/components/modals/ItemGetShippingLabel';
import ItemReturnFormLink from '@/components/modals/ItemReturnFormLink';
import DocumentUpload from '@/components/modals/DocumentUpload';
import ItemPLDecision from './ItemPLDecision';
import AuthQcReport from './AuthQcReport';
import ClientStatsModal from './ClientStats';
import PayByLink from '@/components/modals/PayByLink';
import PayByLinkDetail from './PayByLinkDetail';
import NegoDetails from '@/components/modals/NegoDetails';
import PayoutStatusDetail from './PayoutStatusDetail';
import ShippingReminder from './ShippingReminder';
import AskMoreInfo from './AskMoreInfo/AskMoreInfo';
import RestartOmsWorkflowModal from './RestartOmsWorkflowModal';
import ItemCancelEarlyPayout from './ItemCancelEarlyPayout';

const View: React.FC<{ modal: Modal | null }> = ({ modal }) => {
  if (modal == null) {
    return <></>;
  }

  switch (modal.kind) {
    // ITEM
    case 'Timeline':
      return <Timeline modal={modal} />;
    case 'AuthQcReport':
      return <AuthQcReport modal={modal} />;
    case 'UpdateItemAttribute':
      return <UpdateItemAttribute modal={modal} />;
    case 'UpdateItemDescription':
      return <UpdateItemDescription modal={modal} />;
    case 'UpdateItemComment':
      return <UpdateItemComment modal={modal} />;
    case 'CancelOrder':
      return <CancelOrder modal={modal} />;
    case 'ItemReturnFromWarehouse':
      return <ItemReturnFromWarehouse modal={modal} />;
    case 'ItemAskMoreInfoModal':
      return <AskMoreInfo modal={modal} />;
    case 'ItemRelistSeller':
      return <ItemRelistSeller modal={modal} />;
    case 'ItemRelistWarehouse':
      return <ItemRelistWarehouse modal={modal} />;
    case 'ItemRelistBuyer':
      return <ItemRelistBuyer modal={modal} />;
    case 'ItemReleasePayment':
      return <ItemReleasePayment modal={modal} />;
    case 'ItemProofOfPayment':
      return <ItemProofOfPayment modal={modal} />;
    case 'ItemCancelEarlyPayout':
      return <ItemCancelEarlyPayout modal={modal} />;
    case 'ItemProofOfRefund':
      return <ItemProofOfRefund modal={modal} />;
    case 'ItemReturnToWarehouse':
      return <ItemReturnToWarehouse modal={modal} />;
    case 'ItemReturnToSeller':
      return <ItemReturnToSeller modal={modal} />;
    case 'ItemLostInTransit':
      return <ItemLostInTransit modal={modal} />;
    case 'ItemPLConfirmation':
      return <ItemPLConfirmation modal={modal} />;
    case 'ItemPLDecision':
      return <ItemPLDecision modal={modal} />;
    case 'ItemWithdrawFromSale':
      return <ItemWithdrawFromSale modal={modal} />;
    case 'ItemCurationPriority':
      return <ItemCurationPriority modal={modal} />;
    case 'ItemCurationStatus':
      return <ItemCurationStatus modal={modal} />;
    case 'ItemPhotos':
      return <ItemPhotos modal={modal} />;
    case 'ItemPhotoUpload':
      return <ItemPhotoUpload modal={modal} />;
    case 'ItemPhotoDelete':
      return <ItemPhotoDelete modal={modal} />;
    case 'ItemPhotoOrder':
      return <ItemPhotoOrder modal={modal} />;
    case 'ItemConfirmDelivered':
      return <ItemConfirmDelivered modal={modal} />;
    case 'PayByLink':
      return <PayByLink modal={modal} />;
    case 'PayByLinkDetail':
      return <PayByLinkDetail modal={modal} />;
    case 'PayoutStatusDetail':
      return <PayoutStatusDetail modal={modal} />;
    case 'ShippingReminder':
      return <ShippingReminder modal={modal} />;
    case 'RestartOmsWorkflow':
      return <RestartOmsWorkflowModal modal={modal} />;
    // ORDER
    case 'UpdateOrderDeliveryHome':
      return <UpdateOrderDeliveryHome modal={modal} />;
    case 'RemovePickupDeliveryAddress':
      return <RemovePickupDeliveryAddress modal={modal} />;
    case 'OrderCreateRefund':
      return <OrderCreateRefund modal={modal} />;
    case 'OrderCreateExtraRefund':
      return <OrderCreateExtraRefund modal={modal} />;
    // CLIENT
    case 'UpdateEmail':
      return <UpdateEmail modal={modal} />;
    case 'UpdateClientShippingAddress':
      return <UpdateClientShippingAddress modal={modal} />;
    case 'TalononeNewPromoCode':
      return <TalononeNewPromoCode modal={modal} />;
    case 'TalononeExtendPromoCode':
      return <TalononeExtendPromoCode modal={modal} />;
    case 'TalononeDisablePromoCode':
      return <TalononeDisablePromoCode modal={modal} />;
    case 'ClientActionHisto':
      return <ClientActionHisto modal={modal} />;
    case 'ClientCanceledSales':
      return <ClientCanceledSales modal={modal} />;
    case 'OrderInvoice':
      return <OrderInvoice modal={modal} />;
    case 'ItemOrderAutoCancellation':
      return <ItemOrderAutoCancellation modal={modal} />;
    case 'ItemInterception':
      return <ItemInterception modal={modal} />;
    case 'ItemCreateReturnLitigation':
      return <ItemCreateReturnLitigation modal={modal} />;
    case 'ItemCreateSellerReturnLitigation':
      return <ItemCreateSellerReturnLitigationModal modal={modal} />;
    case 'ItemReplaceReturnLitigation':
      return <ItemReplaceReturnLitigation modal={modal} />;
    case 'ItemSubmitShippingLabel':
      return <ItemSubmitShippingLabel modal={modal} />;
    case 'ItemGetShippingLabel':
      return <ItemGetShippingLabel modal={modal} />;
    case 'ItemReturnFormLink':
      return <ItemReturnFormLink modal={modal} />;
    case 'ClientBadges':
      return <ClientBadges modal={modal} />;
    case 'ClientCsScoreHistory':
      return <ClientCsScoreHistory modal={modal} />;
    case 'ClientSalesReports':
      return <ClientSalesReports modal={modal} />;
    case 'GetPaidManualVerification':
      return <GetPaidManualVerification modal={modal} />;
    case 'DocumentUpload':
      return <DocumentUpload modal={modal} />;
    case 'ClientStats':
      return <ClientStatsModal modal={modal} />;
    // COMMON
    case 'Error':
      return <Error modal={modal} />;
    case 'Loading':
      return <Loading modal={modal} />;
    case 'Success':
      return <Success modal={modal} />;
    case 'NegoDetails':
      return <NegoDetails modal={modal} />;
  }
};
export default View;
